import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";

import { AwsIntegrationView } from "../../../useSearchCloudIntegrations/gql";
import CloudIntegrationsAwsActionsDropdown from "../../ActionsDropdown";

const REFETCH_QUERIES = ["SearchAWSIntegrations"];

const IntegrationsAwsTableDropdownActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AwsIntegrationView>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps}>
      <CloudIntegrationsAwsActionsDropdown
        integration={item}
        trackAnalytics={trackAnalytics}
        refetchQueriesOnEdit={REFETCH_QUERIES}
        refetchQueriesOnDelete={REFETCH_QUERIES}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsTableDropdownActionsCell;
